import {
  DropDown,
  SearchBar,
  NewSiteButton,
  Card,
} from "../components/textField";
import TopNav from "../components/topnav";
import DataTable from "../components/table";
import { useState, useEffect, useMemo } from "react";
import SiteModal from "../components/siteCreationModal";
import { content } from "../utils/data";
import EnhancedTable from "../components/newTable";
import {
  getPermissions,
  getRoles,
  addUser,
  getPermissionStatesDropDown,
  getPermissionLocationDropDown,
  getPermissionsFilter,
  getPermissionSiteDropDown,
  getPermissionDocumentCategory,
  getUsers,
  addPermission,
  permissionDelete,
  editPermission,
  getUsersName,
  permissionDeleteUsers,
  editUser,
} from "../api/serverApi";
import Edit from "../assests/edit.png";
import {
  EditUserPermissionForm,
  UserEditForm,
  UserForm,
  UserPermissionForm,
} from "../components/dropdowns";
import { useMsal } from "@azure/msal-react";
import Delete from "../assests/delete.png";
import Spinner from "../components/spinner";
import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";
import StatusModal from "../components/statusModal";
import {
  getValidAccessToken,
  getTeamsUserInfo,
  fetchUserDetailsByEmail,
} from "../services/garphService";
import { Button } from "@mui/material";
import * as microsoftTeams from "@microsoft/teams-js";

const AccessManager = () => {
  const [open, setOpen] = useState(false);
  const [openPermission, setOpenPermission] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
 
  const { instance, accounts } = useMsal();
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [firstPersonName, setFirstName] = useState("");
  const [lastPersonName, setLastName] = useState("");
  const [error, setError] = useState(null);
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [documentCategory, setDocumentCategory] = useState([]);
  const [selectedDocumentCategory, setSelectedDocumentCategory] = useState([]);
  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [selectedSiteId, setSelecteSiteId] = useState("");
  const [users, setUsers] = useState([]);
  const [usersFilter, setUsersFilter] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const [selectedUsersId, setSelectedUsersId] = useState("");
  const [editingAccessId, setEditingAccessId] = useState(null);
  const [editingUserId, setEditingUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [name, setName] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("");

const handlePermissionClose = () => {
  setOpenPermission(false);
  resetForm();
  setSelectedRoleName("");
};

  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");

  const [activeTab, setActiveTab] = useState("users");

  useEffect(() => {
    if (tabParam === "permissions") {
      setActiveTab("permissions");
    } else {
      setActiveTab("users");
    }
  }, [tabParam]);

  const handlePermissionOpen = () => {
    setSelectedUsers("");
    setSelectedStateId([]);
    setSelectedLocationId([]);
    setSelecteSiteId("");
    setSelectedDocumentCategory([]);
    setIsEditing(false); // Ensure that isEditing is set to false for creating a new site
    setOpenPermission(true); // Open the modal for site creation
    // Optionally reset state-related fields
  };
  const handleUserOpen = () => {
    setIsEditing(false);
    setEmail("");
    setFirstName("");
    setLastName("");
    setSelectedRoleId("");
    setOpen(true);
  };
  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };
  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getPermissions(token);
        setResponseData(response.data);
        console.log(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchPermissions();
  }, [instance, accounts]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getUsersName(token);
        setName(response.data);
        console.log(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [instance, accounts]);

  useEffect(() => {
    getRoles()
      .then((response) => {
        setRoles(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const fetchUsers = async () => {
    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const response = await getUsers(token);
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchPermissionsFilter = () => {
    getPermissionsFilter()
      .then((response) => {
        setUsersFilter(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    fetchPermissionsFilter();
    fetchUsers();
  }, []);

  const rowsWithActions = useMemo(() => {
    if (!responseData || responseData.length === 0) return [];

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const lowerSearch = searchTerm.toLowerCase();
    console.log(responseData?.permissions);

    return responseData.flatMap(
      ({ user_name, user_id, role_name, permissions }) =>
        (permissions || [])
          .map(
            ({
              access_id,
              state_name,
              location_name,
              site_name,
              created_at,
              category_name,
            }) => {
              const categoryString = Array.isArray(category_name)
                ? category_name.join(", ")
                : category_name || "";

              return {
                key: access_id,
                user_name,
                user_id,
                role_name,
                state_name,
                location_name,
                site_name,
                category_name: categoryString,
                created_at: formatDate(created_at),
                actions: (
                  <div className="flex justify-center items-center ml-10">
                    <img
                      src={Edit}
                      alt="Edit"
                      style={{
                        width: "20px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                      onClick={() => handleEdit(access_id)}
                    />
                    <img
                      src={Delete}
                      alt="delete"
                      style={{
                        width: "20px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                      onClick={() => handleDelete(access_id)}
                    />
                  </div>
                ),
              };
            },
          )
          .filter((row) =>
            [
              row.user_name,
              row.state_name,
              row.location_name,
              row.site_name,
              row.category_name, // now a joined string
              row.user_id,
            ].some((field) =>
              String(field || "")
                .toLowerCase()
                .includes(lowerSearch),
            ),
          ),
    );
  }, [responseData, searchTerm]);

  const filteredRows = rowsWithActions.filter((row) => {
    const matchUsers = selectedUsersId ? row.user_id === selectedUsersId : true;
    return matchUsers;
  });

  const rowsWithActionsUsers = useMemo(() => {
    if (!name || name.length === 0) return [];

    const lowerSearch = searchTerm.toLowerCase();

    return name
      .map(({ first_name, last_name, role, email, user_id }) => ({
        first_name,
        last_name,
        role,
        email,
        user_id,
        actions: (
          <div className="flex justify-center items-center ml-10">
            <img
              src={Edit}
              alt="delete"
              style={{ width: "20px", cursor: "pointer", marginRight: "10px" }}
              onClick={() => handleRoleEdit(user_id)}
            />
            <img
              src={Delete}
              alt="delete"
              style={{ width: "20px", cursor: "pointer", marginRight: "10px" }}
              onClick={() => handleDeleteRole(user_id)}
            />
          </div>
        ),
      }))
      .filter((row) =>
        [row.first_name, row.last_name, row.role, row.email, row.user_id].some(
          (field) =>
            String(field || "")
              .toLowerCase()
              .includes(lowerSearch),
        ),
      );
  }, [name, searchTerm]);

  const filteredRowsUsers = rowsWithActionsUsers.filter((row) => {
    const matchUsers = selectedUsersId ? row.user_id === selectedUsersId : true;
    return matchUsers;
  });

  const handleDelete = async (accessId) => {
    if (!accessId) return;

    setLoading(true);

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      console.log(token);
      await permissionDelete(accessId, token); // ✅ pass token
      const response = await getPermissions(token); // ✅ use same fresh token

      setResponseData(response.data);
      setResponseMessage("Permission deleted successfully");
      setIsSuccess(true);
      setModalOpen(true);
      fetchPermissionsFilter();
      fetchUsers();
    } catch (error) {
      console.error("❌ Delete failed:", error);

      const details = error.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage("Failed to delete permission. Try again.");
      }

      setIsSuccess(false);
      setModalOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteRole = async (userId) => {
    if (!userId) return;

    setLoading(true);

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      console.log(token);

      await permissionDeleteUsers(userId, token); // ✅ pass token

      const response = await getUsersName(token); // ✅ re-fetch with token

      setName(response.data);
      setResponseMessage("Permission deleted successfully");
      setIsSuccess(true);
      setModalOpen(true);
      setOpen(false);
      setIsEditing(false);
      setOpenPermission(false);
      resetSurveyForm();
      fetchPermissionsFilter();
      fetchUsers();

setTimeout(() => {
  window.location.reload();
}, 500);
    } catch (error) {
      console.error("❌ Delete failed:", error);

      const details = error.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(
          details || "Failed to delete permission. Try again.",
        );
      }

      setIsSuccess(false);
      setModalOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleEditUsers = async (userId) => {
    if (!userId) return;

    setLoading(true);

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      console.log(token);
      const data = {
        role_id: selectedRoleId,
      };
      await editUser(userId, data, token); // ✅ pass token

      const response = await getUsersName(token); // ✅ re-fetch with token

      setName(response.data);
      setResponseMessage("Permission edited successfully");
      setIsSuccess(true);
      setModalOpen(true);
      setOpen(false);
      setIsEditing(false);
      setOpenPermission(false);
      resetSurveyForm();
      fetchPermissionsFilter();
      fetchUsers();
     setTimeout(() => {
  window.location.reload();
}, 500);
    } 
    
   catch (error) {
  const details = error.response?.data?.detail;

  setOpen(false);          // Close Edit User modal first

  setResponseMessage(
    details || "Failed to update user. Try again."
  );

  setIsSuccess(false);
  setModalOpen(true);
}finally {
      setLoading(false);
    }
  };

  const handleEmailBlur = async () => {
    const trimmedEmail = email?.trim();
    if (!trimmedEmail || !trimmedEmail.includes("@")) return;

    try {
      console.log("📤 Fetching user for email:", trimmedEmail);
      const userDetails = await fetchUserDetailsByEmail(
        instance,
        accounts,
        trimmedEmail,
      );

      console.log("✅ Got user:", userDetails);
      setFirstName(userDetails.firstName);
      setLastName(userDetails.lastName);
      setError(null);
    } catch (err) {
      console.error("❌ Failed to fetch user details:", err);
      setFirstName("");
      setLastName("");
      setError("User not found or unauthorized.");
    }
  };

  // Debug: log when state changes
  useEffect(() => {
    console.log("Updated state firstPersonName:", firstPersonName);
    console.log("Updated state lastPersonName:", lastPersonName);
  }, [firstPersonName, lastPersonName]);

  const handleUserSubmit = async () => {
    if (!email?.trim() || !firstPersonName?.trim()) {
      setResponseMessage("First name, last name, and email are required.");
      setIsSuccess(false);
      setModalOpen(true);
      
      return;
    }

    setLoading(true);

    const data = {
      first_name: firstPersonName,
      last_name: lastPersonName || "",
      role_id: selectedRoleId,
      email,
    };

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      await addUser(data, token);
      const response = await getUsersName(token);
      setName(response.data);

      const usersResponse = await getUsers(token);
      setUsers(usersResponse.data);

      setResponseMessage("User added successfully");
      setIsSuccess(true);
      fetchPermissionsFilter(); // your logic
      setModalOpen(true);
      setOpen(false); // closes Add User modal
      resetSurveyForm();
      fetchUsers(); // your logic
 } catch (error) {
  console.error("❌ Failed to assign permission:", error);

  const details = error.response?.data?.detail;

  setResponseMessage(
    Array.isArray(details)
      ? details.map((e) => e.msg).join(", ")
      : details || "An unexpected error occurred",
  );

  setIsSuccess(false);

  // Reset the Add User fields
  resetSurveyForm();

  // Close Add User modal
  setOpen(false);

  // Show backend error modal
  setModalOpen(true);
}
  };

  const resetSurveyForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setSelectedRoleId("");
  };

  useEffect(() => {
    // setLoading(true);
    getPermissionStatesDropDown()
      .then((response) => {
        // Handle succesasful response
        setGetState(response.data);
        console.log(response);
        setSelectedLocationId([]);
        setSelecteSiteId("");

        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error("Error:", error);
        // setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //     if (selectedStateId) {
  //         getPermissionLocationDropDown({ state_id: selectedStateId })
  //             .then((response) => {
  //                 setGetLocation(response.data);
  //                 console.log(response)
  //             }).catch((error) => {
  //                 // Handle error
  //                 // setshowModal(true);
  //                 // setModalTitle("Something went wrong, Please try again");
  //                 console.error('Error:', error);
  //                 // setLoading(false);
  //             });
  //     } else {
  //         setGetLocation([]);
  //         setSelectedLocationId('');
  //         setSelecteSiteId('');
  //     }
  // }, [selectedStateId]);
  useEffect(() => {
    // State Admin
    // multiple states allowed
    // no location API needed

    if (selectedRoleName === "State Admin") {
      setGetLocation([]);
      setSelectedLocationId([]);
      setSelecteSiteId("");
      return;
    }

    // Other roles

    if (selectedStateId?.length > 0) {
      const firstStateId = selectedStateId[0]?.state_id;

      getPermissionLocationDropDown({
        state_id: firstStateId,
      })
        .then((response) => {
          setGetLocation(response.data);

          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setGetLocation([]);
      setSelectedLocationId([]);
      setSelecteSiteId("");
    }
  }, [selectedStateId, selectedRoleName]);

  useEffect(() => {
    if (selectedRoleName !== "Location Admin" && selectedLocationId) {
      getPermissionSiteDropDown({
        location_id: selectedLocationId,
      })
        .then((response) => {
          setGetSite(response.data);
          console.log(response);
        })
        .catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error("Error:", error);
          // setLoading(false);
        });
    } else {
      setGetSite([]);
      setSelecteSiteId("");
    }
  }, [selectedLocationId, selectedRoleName]);

  useEffect(() => {
    // setLoading(true);
    getPermissionDocumentCategory()
      .then((response) => {
        // Handle succesasful response
        setDocumentCategory(response.data);

        console.log(response);

        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error("Error:", error);
        // setLoading(false);
      });
  }, []);

  const handleUserPermission = async () => {
    setLoading(true);

    const category_id = Array.isArray(selectedDocumentCategory)
      ? selectedDocumentCategory.map((item) =>
          typeof item === "object" ? item.category_id : item,
        )
      : [];

    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const stateId = Array.isArray(selectedStateId)
        ? selectedStateId.map((item) => item.state_id)
        : [];

      const data = {
        user_id: selectedUsers,

        state_id: selectedStateId.map((item) => item.state_id),

        location_id:
          selectedRoleName === "Location Admin"
            ? selectedLocationId.map((item) => item.location_id)
            : selectedRoleName === "State Admin"
              ? null
              : [Number(selectedLocationId)],

        site_id:
          selectedRoleName === "State Admin" ||
          selectedRoleName === "Location Admin"
            ? null
            : selectedSiteId,

        category_ids: category_id,
      };
      console.log("Payload:", data);

      await addPermission(data, token);

      const response = await getPermissions(token);

      setResponseData(response.data);

      setResponseMessage("Permission assigned successfully");
      setIsSuccess(true);
      setModalOpen(true);

      setOpenPermission(false);

      resetForm();

      fetchPermissionsFilter();
      fetchUsers();
    } catch (error) {
      console.error("❌ Failed to assign permission:", error);

      const details = error.response?.data?.detail;

      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");

        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      setModalOpen(true);

      setOpenPermission(false);

      resetForm();
    } 
    
    
    finally {
      setLoading(false);
    }
  };

  const handleRoleEdit = (user_id) => {
    // Find the permission object by access_id inside responseData.users.permissions
    const site = name?.find((p) => p.user_id === user_id);

    if (site) {
      setEmail(site.email || "");
      setFirstName(site.first_name || "");
      setLastName(site.last_name || "");
      setSelectedRoleId(site.role_id || "");
      setIsEditing(true);
      setOpen(true);
      setEditingUserId(site.user_id);

      console.log("Site Data:", site);
      console.log("Response Data:", name);
    } else {
      console.error("Site not found with user_id:", user_id);
    }
  };

  const handleEdit = (access_id) => {
    // Find the permission object by access_id inside responseData.users.permissions
    const site = responseData
      ?.flatMap(
        (user) =>
          user.permissions?.map((p) => ({
            ...p,
            user_name: user.user_name,
            role_name: user.role_name,
          })) || [],
      )
      ?.find((p) => p.access_id === access_id);

    if (site) {
      // ADD THIS role name is needed to handle the state admin scenario where location and site dropdowns are not applicable
      setSelectedRoleName(site.role_name || "");
      setUserName(site.user_name || "");
      setSelectedStateId(
        getState.filter((item) =>
          Array.isArray(site.state_id)
            ? site.state_id.includes(item.state_id)
            : item.state_id === site.state_id,
        ),
      );

      console.log("ROLE", site.role_name);
      console.log("LOCATION_ID", site.location_id);
      console.log("selectedLocationId before set", selectedLocationId);

      if (site.role_name === "Location Admin") {
        setSelectedLocationId([
          {
            location_id: site.location_id,
            name: site.location_name,
          },
        ]);
      } else {
        setSelectedLocationId(site.location_id || "");
      }

      setSelecteSiteId(site.site_id || "");
      setSelectedDocumentCategory(
        site.category_id != null
          ? documentCategory.filter((item) =>
              Array.isArray(site.category_id)
                ? site.category_id.includes(item.category_id)
                : site.category_id === item.category_id,
            )
          : [],
      );

      setIsEditing(true);
      setOpenPermission(true);
      setEditingAccessId(site.access_id);

      console.log("Site Data:", site);
      console.log("Response Data:", responseData);
    } else {
      console.error("Site not found with access_id:", access_id);
    }
  };

  const EditPermission = async (accessId) => {
    if (!accessId) return;

    setLoading(true);

    const category_id = Array.isArray(selectedDocumentCategory)
      ? selectedDocumentCategory.map((item) =>
          typeof item === "object" ? item.category_id : item,
        )
      : [];

    try {
      let token;

      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const stateId = selectedStateId?.[0]?.state_id || null;

      const data = {
        state_id: stateId,
        category_ids: category_id,
      };

      if (selectedRoleName !== "State Admin") {
        data.location_id =
          selectedRoleName === "Location Admin"
            ? selectedLocationId?.[0]?.location_id
            : Number(selectedLocationId);

        data.site_id = selectedSiteId || "";
      }
      console.log(typeof data.site_id);
      console.log(typeof data.location_id);
      console.log(data);
      await editPermission(accessId, data, token);

      const response = await getPermissions(token);

      setResponseData(response.data);

      setResponseMessage("Permission updated successfully");

      setIsSuccess(true);

      setModalOpen(true);

      setOpen(false);

      setIsEditing(false);

      setOpenPermission(false);

      resetForm();

      fetchPermissionsFilter();

      fetchUsers();
    } catch (error) {
      console.error("❌ Failed to update permission:", error);

      const details = error?.response?.data?.detail;

      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");

        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);

      setModalOpen(true);

      setOpenPermission(false);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setSelectedUsers("");
    setSelectedStateId([]);
    setSelectedLocationId([]);
    setSelecteSiteId("");
    setSelectedDocumentCategory([]);
  };

  return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl">Access Manager</div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="User"
            placeholder="None"
            responseData={usersFilter}
            labelKey="full_name"
            valueKey="user_id"
            value={selectedUsersId}
            onChange={(e) => {
              setSelectedUsersId(e.target.value);
            }}
          />
        </div>

        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setSelectedUsersId(null);
              setSearchTerm("");
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "10px",
              whiteSpace: "nowrap", // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>

        <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
          {/* {activeTab === 'users' && (
                            <NewSiteButton Name="Add User" handleOpen={handleUserOpen} />
                        )}
                        {activeTab === 'permissions' && (
                            <NewSiteButton Name="Add Permission" handleOpen={handlePermissionOpen} />
                        )} */}
          <SiteModal
            open={open}
            handleClose={() => handleClose(false)}
            title={isEditing ? "Edit User" : "Add a New User"}
            handleSubmit={
              isEditing
                ? () => handleEditUsers(editingUserId)
                : handleUserSubmit
            }
            formContent={
              isEditing ? (
                <UserEditForm
                  isEditing={true}
                  email={email}
                  firstName={firstPersonName}
                  lastName={lastPersonName}
                  responseDataRole={roles}
                  roleName="role_name"
                  selectedRole="role_id"
                  onChangeRole={(e) => setSelectedRoleId(e.target.value)}
                  roleId={selectedRoleId}
                />
              ) : (
                <UserForm
                  email={email}
                  onChangeEmail={(e) => setEmail(e.target.value)}
                  handleEmailBlur={handleEmailBlur}
                  firstName={firstPersonName}
                  lastName={lastPersonName}
                  responseDataRole={roles}
                  roleName="role_name"
                  selectedRole="role_id"
                  onChangeRole={(e) => setSelectedRoleId(e.target.value)}
                  roleId={selectedRoleId}
                />
              )
            }
          />
          <SiteModal
            open={openPermission}
           handleClose={handlePermissionClose}
            title={isEditing ? "Edit Permission" : "Add User Permission"}
            handleSubmit={
              isEditing
                ? () => EditPermission(editingAccessId)
                : handleUserPermission
            }
            formContent={
              isEditing ? (
                <EditUserPermissionForm
                  userName={userName}
                  isEditing={isEditing}
                  responseDataState={getState}
                  stateName="name"
                  selectedStateID="state_id"
                  responseDataSite={getSite}
                  responseDataLocation={getLocation}
                  locationName="name"
                  selectedLocationID="location_id"
                  siteName="name"
                  selectedSiteID="site_id"
                  selectedDocumentCategory={selectedDocumentCategory}
                  setSelectedDocumentCategory={setSelectedDocumentCategory}
                  responseDataCategory={documentCategory}
                  StateId={selectedStateId}
                  locationId={selectedLocationId}
                  siteId={selectedSiteId}
                  roleName={selectedRoleName}
                  onChangeLocation={(e) => {
                    if (selectedRoleName === "Location Admin") {
                      const selectedLocation = getLocation.find(
                        (item) => item.location_id === Number(e.target.value),
                      );

                      setSelectedLocationId(
                        selectedLocation
                          ? [
                              {
                                location_id: selectedLocation.location_id,
                                name: selectedLocation.name,
                              },
                            ]
                          : [],
                      );
                    } else {
                      setSelectedLocationId(Number(e.target.value));
                    }
                  }}
                  onChangeState={(e) => {
                    const selected = getState.find(
                      (s) => s.state_id === Number(e.target.value),
                    );

                    setSelectedStateId(selected ? [selected] : []);
                  }}
                  onChangeSite={(e) => setSelecteSiteId(e.target.value)}
                />
              ) : (
                <UserPermissionForm
                  responseDataState={getState}
                  stateName="name"
                  selectedStateID="state_id"
                  responseDataSite={getSite}
                  responseDataLocation={getLocation}
                  locationName="name"
                  selectedLocationID="location_id"
                  siteName="name"
                  selectedSiteID="site_id"
                  responseDataCategory={documentCategory}
                  StateId={selectedStateId}
                  locationId={selectedLocationId}
                  siteId={selectedSiteId}
                  roleName={selectedRoleName}
                  selectedDocumentCategory={selectedDocumentCategory}
                  setSelectedDocumentCategory={setSelectedDocumentCategory}
                  onChangeLocation={(value) => {
                    if (selectedRoleName === "Location Admin") {
                      setSelectedLocationId(value);
                    } else {
                      setSelectedLocationId(Number(value.target.value));
                    }
                  }}
                  onChangeState={(value) => setSelectedStateId(value)}
                  onChangeSite={(e) => setSelecteSiteId(Number(e.target.value))}
                  onChangeUser={(e) => {
                    const userId = e.target.value;

                    setSelectedUsers(userId);

                    const selectedUser = name.find((u) => u.user_id === userId);

                    setSelectedRoleName(selectedUser?.role || "");
                  }}
                  responseDataUser={users}
                  userName="full_name"
                  selectedUserID="user_id"
                  userId={selectedUsers}
                />
              )
            }
          />
        </div>
      </div>
      <div className="px-[35px] py-2">
        {/* Internal Tab Headers */}
        <div className="flex gap-6 text-gray-600 text-lg pb-2">
          <button
            onClick={() => setActiveTab("users")}
            className={`transition-colors pb-1 border-b-2 ${
              activeTab === "users"
                ? "text-blue-600 font-bold border-b-blue-600"
                : "border-b-transparent"
            }`}
          >
            Users
          </button>
          <button
            onClick={() => setActiveTab("permissions")}
            className={`transition-colors pb-1 border-b-2 ${
              activeTab === "permissions"
                ? "text-blue-600 font-bold border-b-blue-600"
                : "border-b-transparent"
            }`}
          >
            User Permission
          </button>
        </div>

        {/* Internal Tab Content */}
        {activeTab === "users" && (
          <div className="flex flex-wrap">
            <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
              <NewSiteButton Name="Add User" handleOpen={handleUserOpen} />
            </div>
            <EnhancedTable
              rows={filteredRowsUsers}
              header={content.users}
              height="320px"
            />
          </div>
        )}
        {activeTab === "permissions" && (
          <div className="flex flex-wrap">
            <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
              <NewSiteButton
                Name="Add Permission"
                handleOpen={handlePermissionOpen}
              />
            </div>
            <EnhancedTable
              rows={filteredRows}
              header={content.accessManagerHeadCells}
              height="320px"
            />
          </div>
        )}
      </div>

      {loading && <Spinner />}
   <StatusModal
  isOpen={isModalOpen}
  onClose={() => {
    setModalOpen(false);
    window.location.reload();
  }}
  message={responseMessage}
  isSuccess={isSuccess}
/>
    </>
  );
};

export default AccessManager;
